import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

const VillageHouseDeclaration: React.FC = () => {
  useSEO({
    title: '村屋僭建物申報 BD T1 BD T3 安全檢驗 - 焯峯工程 | 專業代辦服務',
    description: '焯峯工程提供專業村屋僭建物申報及安全檢驗服務，涵蓋BD T1、BD T3監督範疇。一站式完成六步申報流程，確保符合屋宇署要求。提供結構安全證明報告、五年續期檢驗服務。$3,500起，立即WhatsApp查詢91898819獲取免費諮詢。',
    keywords: '村屋僭建物申報,BD T1,BD T3,TCP T1,TCP T3,RSE T3,國內T1,新界村屋申報,僭建物安全檢驗,屋宇署申報,NT-01申報表,結構安全報告,村屋續期檢驗,焯峯工程',
    canonical: '/village-house-declaration',
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "新界村屋僭建物申報及安全檢驗服務 BD T1 BD T3",
      "description": "專業處理村屋僭建物申報，涵蓋BD T1、BD T3監督範疇，確保符合屋宇署要求，為您的物業提供全面的安全檢驗服務",
      "provider": {
        "@type": "Organization",
        "name": "焯峯工程有限公司",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
      },
      "areaServed": {
        "@type": "Place",
        "name": "香港新界"
      },
      "offers": {
        "@type": "Offer",
        "priceSpecification": {
          "@type": "PriceSpecification",
          "price": "3500",
          "priceCurrency": "HKD"
        }
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-red-50 to-red-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              新界村屋僭建物申報及安全檢驗計劃
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              專業處理村屋僭建物申報，確保符合屋宇署要求，為您的物業提供全面的安全檢驗服務
            </p>
          </div>
        </div>
      </section>

      {/* 申報流程 - 簡化設計 */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">一站式完成六步申報</h2>
            <p className="text-lg text-gray-600">我們為您提供完整的代辦服務</p>
          </div>
          
          <div className="flex flex-col lg:flex-row items-center justify-center space-y-8 lg:space-y-0 lg:space-x-4">
            {/* 步驟 1 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-3">
                <i className="ri-file-edit-line text-white text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">填寫表格</h3>
              <p className="text-xs text-gray-600 max-w-20">NT-01申報表</p>
            </div>
            
            {/* 箭頭 */}
            <div className="hidden lg:block">
              <i className="ri-arrow-right-line text-gray-400 text-2xl"></i>
            </div>
            <div className="lg:hidden">
              <i className="ri-arrow-down-line text-gray-400 text-2xl"></i>
            </div>
            
            {/* 步驟 2 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-3">
                <i className="ri-camera-line text-white text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">拍照量度</h3>
              <p className="text-xs text-gray-600 max-w-20">現場記錄尺寸</p>
            </div>
            
            {/* 箭頭 */}
            <div className="hidden lg:block">
              <i className="ri-arrow-right-line text-gray-400 text-2xl"></i>
            </div>
            <div className="lg:hidden">
              <i className="ri-arrow-down-line text-gray-400 text-2xl"></i>
            </div>
            
            {/* 步驟 3 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-3">
                <i className="ri-search-line text-white text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">安全勘察</h3>
              <p className="text-xs text-gray-600 max-w-20">結構評估</p>
            </div>
            
            {/* 箭頭 */}
            <div className="hidden lg:block">
              <i className="ri-arrow-right-line text-gray-400 text-2xl"></i>
            </div>
            <div className="lg:hidden">
              <i className="ri-arrow-down-line text-gray-400 text-2xl"></i>
            </div>
            
            {/* 步驟 4 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-3">
                <i className="ri-folder-line text-white text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">整理資料</h3>
              <p className="text-xs text-gray-600 max-w-20">圖則及相片</p>
            </div>
            
            {/* 箭頭 */}
            <div className="hidden lg:block">
              <i className="ri-arrow-right-line text-gray-400 text-2xl"></i>
            </div>
            <div className="lg:hidden">
              <i className="ri-arrow-down-line text-gray-400 text-2xl"></i>
            </div>
            
            {/* 步驟 5 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-3">
                <i className="ri-send-plane-line text-white text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">遞交申報</h3>
              <p className="text-xs text-gray-600 max-w-20">專人送交</p>
            </div>
            
            {/* 箭頭 */}
            <div className="hidden lg:block">
              <i className="ri-arrow-right-line text-gray-400 text-2xl"></i>
            </div>
            <div className="lg:hidden">
              <i className="ri-arrow-down-line text-gray-400 text-2xl"></i>
            </div>
            
            {/* 步驟 6 */}
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-3">
                <i className="ri-check-line text-white text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">完成申報</h3>
              <p className="text-xs text-gray-600 max-w-20">合規確認</p>
            </div>
          </div>
          
          {/* 結構安全證明報告 */}
          <div className="mt-12">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-shield-check-line text-red-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">結構安全證明報告</h3>
                  <p className="text-gray-600">由T2技術人員及註冊工程師進行專業評估，業主須於申報後6個月內提交首份報告</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* 簡化說明 */}
          <div className="text-center mt-8">
            <div className="bg-red-50 rounded-lg p-6 max-w-2xl mx-auto">
              <h4 className="text-lg font-semibold text-red-900 mb-2">即時查詢</h4>
              <p className="text-red-700 text-2xl font-bold mb-4">$3,500起</p>
              <a 
                href="https://wa.me/85291898819"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line mr-2 text-xl"></i>
                WhatsApp 查詢
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* 申報資格要求 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">申報資格要求</h2>
            <p className="text-lg text-gray-600">申報僭建物須符合屋宇署以下資格要求</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-100">
              <div className="w-full h-32 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/3ee147229aa0c92e43b1dbd5857a5a1c.png"
                  alt="天台覆蓋面積"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">天台覆蓋面積</h3>
              <p className="text-gray-600">符合屋宇署規定的覆蓋面積標準</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-100">
              <div className="w-full h-32 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/7665cfd3057304bb73f3092bceefdde8.jpeg"
                  alt="圍封結構"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">圍封結構</h3>
              <p className="text-gray-600">檢查是否有不當圍封結構</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-100">
              <div className="w-full h-32 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/6df7279641656028796d3f8fed2c92ec.png"
                  alt="間牆厚度"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">間牆厚度</h3>
              <p className="text-gray-600">確保間牆厚度符合安全標準</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-100">
              <div className="w-full h-32 mb-4 rounded-lg overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/de118b518e1d09dd3e813d8771719d01/ff4e09b26c02b8473b511c8cb8836d63.jpeg"
                  alt="簷篷支撐"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">簷篷支撐</h3>
              <p className="text-gray-600">檢查簷篷是否有適當支撐結構</p>
            </div>
          </div>
        </div>
      </section>

      {/* 五年一次續期檢驗服務 */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">五年一次續期檢驗服務</h2>
            <p className="text-lg text-gray-600">確保村屋僭建物持續符合安全標準</p>
          </div>

          {/* 服務流程 */}
          <div className="bg-white rounded-lg p-8 shadow-lg border border-gray-100 mb-8">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">完整服務流程</h3>
            <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-home-4-line text-red-600"></i>
                </div>
                <span className="text-gray-700 font-medium">上門檢驗</span>
              </div>
              
              <div className="hidden md:block">
                <i className="ri-arrow-right-line text-gray-400 text-xl"></i>
              </div>
              <div className="md:hidden">
                <i className="ri-arrow-down-line text-gray-400 text-xl"></i>
              </div>
              
              <div className="flex items-center">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-file-edit-line text-red-600"></i>
                </div>
                <span className="text-gray-700 font-medium">製作報告</span>
              </div>
              
              <div className="hidden md:block">
                <i className="ri-arrow-right-line text-gray-400 text-xl"></i>
              </div>
              <div className="md:hidden">
                <i className="ri-arrow-down-line text-gray-400 text-xl"></i>
              </div>
              
              <div className="flex items-center">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-send-plane-line text-green-600"></i>
                </div>
                <span className="text-gray-700 font-medium">提交至屋宇署</span>
              </div>
            </div>
          </div>

          {/* 服務時間 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-red-50 rounded-lg p-6 border border-red-200">
              <div className="flex items-center mb-3">
                <i className="ri-time-line text-red-600 text-xl mr-2"></i>
                <h4 className="text-lg font-semibold text-red-900">標準流程</h4>
              </div>
              <p className="text-red-700">安排上門直至提交至屋宇署所有流程只需 <strong>14個工作天</strong></p>
            </div>
            
            <div className="bg-orange-50 rounded-lg p-6 border border-orange-200">
              <div className="flex items-center mb-3">
                <i className="ri-flashlight-line text-orange-600 text-xl mr-2"></i>
                <h4 className="text-lg font-semibold text-orange-900">特快流程</h4>
              </div>
              <p className="text-orange-700">緊急情況下，特快流程只需 <strong>3個工作天</strong></p>
            </div>
          </div>
          
          <div className="text-center">
            <div className="bg-green-50 rounded-lg p-6 max-w-2xl mx-auto">
              <h4 className="text-lg font-semibold text-green-900 mb-2">重要提醒</h4>
              <p className="text-green-700">村屋僭建物申報後需每五年進行一次續期檢驗，我們提供完整的續期服務</p>
            </div>
          </div>
        </div>
      </section>

      {/* 屋宇署審核補件情況 - 簡化版 */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">常見補件情況</h2>
            <p className="text-gray-600">如收到「未能進一步處理申報」通知的可能原因</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <div className="bg-white rounded-lg p-4 shadow text-center">
              <i className="ri-map-line text-yellow-600 text-2xl mb-2"></i>
              <p className="text-sm text-gray-700">圖則問題</p>
            </div>
            
            <div className="bg-white rounded-lg p-4 shadow text-center">
              <i className="ri-door-line text-yellow-600 text-2xl mb-2"></i>
              <p className="text-sm text-gray-700">圍封結構</p>
            </div>
            
            <div className="bg-white rounded-lg p-4 shadow text-center">
              <i className="ri-building-line text-yellow-600 text-2xl mb-2"></i>
              <p className="text-sm text-gray-700">建築位置</p>
            </div>
            
            <div className="bg-white rounded-lg p-4 shadow text-center">
              <i className="ri-file-edit-line text-yellow-600 text-2xl mb-2"></i>
              <p className="text-sm text-gray-700">表格問題</p>
            </div>
            
            <div className="bg-white rounded-lg p-4 shadow text-center">
              <i className="ri-percent-line text-yellow-600 text-2xl mb-2"></i>
              <p className="text-sm text-gray-700">覆蓋面積</p>
            </div>
            
            <div className="bg-red-50 rounded-lg p-4 border border-red-200 text-center">
              <i className="ri-phone-line text-red-600 text-2xl mb-2"></i>
              <button 
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="text-sm text-red-700 hover:text-red-800 cursor-pointer"
              >
                需要協助？
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">需要村屋僭建物申報服務？</h2>
          <p className="text-xl text-red-100 mb-8">立即聯絡我們，獲得專業諮詢和一站式代辦服務</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              免費諮詢
            </button>
            <a 
              href="https://wa.me/85291898819"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp 諮詢
            </a>
            <button 
              onClick={() => {
                window.REACT_APP_NAVIGATE('/');
                setTimeout(() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              }}
              className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              填寫表格
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VillageHouseDeclaration;
